import { X } from "react-feather"

export const VideoPlayerPopup = ({ videoUrl, onClose }) => {
  // Embed links (player.mediadelivery.net) need an iframe, normal files use <video>
  const isEmbed = videoUrl.includes("player.mediadelivery.net/embed/")

  return (
    <div className="seminar-backdrop custom video-player-backdrop" onClick={onClose}>
      <div
        className="modal-dialog modal-dialog-centered video-player-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content seminar-content video-player-content">

          {/* Header */}
          <div className="d-flex align-items-center justify-content-between seminar-header">
            <h6 className="m-0 fw-bold">Video Player</h6>
            <button
              type="button"
              className="btn-close btn-close-white seminar-close"
              onClick={onClose}
            />
          </div>

          {/* Video */}
          <div className="video-player-body">
            {isEmbed ? (
              <iframe
                src={videoUrl}
                title="Video player"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                className="video-player-element"
              />
            ) : (
              <video src={videoUrl} controls className="video-player-element" />
            )}
          </div>

          {/* Footer */}
          {/* <div className="d-flex justify-content-end seminar-footer">
            <button type="button" className="btn btn-danger seminar-btn-cancel" onClick={onClose}>
              <X size={15} className="me-1" />
              Close
            </button>
          </div> */}

        </div>
      </div>
    </div>
  )
}